var _g, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgVasanaChartLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 107,
    viewBox: "0 0 100 107",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_bdd_0_1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M50 66.0588C66.5685 66.0588 80 52.8249 80 36.5C80 20.1751 66.5685 6.94116 50 6.94116C33.4315 6.94116 20 20.1751 20 36.5C20 52.8249 33.4315 66.0588 50 66.0588Z",
    fill: "white"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M43.2832 41.2414C43.0723 41.6067 43.0723 42.0541 43.2832 42.4194L48.6989 51.8335C49.1515 52.6196 50.2822 52.6196 50.7349 51.8335C50.9458 51.4682 50.9458 51.0187 50.7349 50.6555L45.3192 41.2414C44.8665 40.4554 43.7359 40.4554 43.2832 41.2414Z",
    fill: "#8B3F9E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M48.6993 51.8374C49.1498 52.6214 50.2806 52.6235 50.7332 51.8374L66.3472 24.7855C66.7999 24.0015 66.2344 23.0205 65.3312 23.0205C64.9113 23.0205 64.5241 23.2442 64.3132 23.6075L48.6993 50.6594C48.4883 51.0226 48.4883 51.4721 48.6993 51.8354V51.8374Z",
    fill: "#8B3F9E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M49.7272 48.8922L49.2541 49.711C48.949 50.2405 48.2791 50.4355 47.7363 50.1523C47.7363 50.1523 48.5065 51.472 48.7052 51.8352C48.9038 52.1985 49.293 52.4222 49.7272 52.4222C50.1615 52.4222 50.5056 52.2436 50.7391 51.8373C50.9746 51.4288 51.6546 50.2488 51.6546 50.2488L49.7252 48.8901L49.7272 48.8922Z",
    fill: "#8B3F9E"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M55.5514 31.7513C56.1127 32.0777 56.8316 31.8847 57.1553 31.3224L60.9303 24.7816C61.3829 23.9976 60.8176 23.0166 59.9143 23.0166C59.4944 23.0166 59.1074 23.2403 58.8963 23.6036L55.1214 30.1444C54.7957 30.7067 54.9882 31.4271 55.5495 31.7513H55.5514Z",
    fill: "#B77EC5"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M52.7688 34.2174L48.5504 41.5266C48.2259 42.0888 48.4178 42.8081 48.9789 43.1333L48.9807 43.1343C49.5417 43.4594 50.2597 43.2672 50.5842 42.705L54.8027 35.3958C55.127 34.8336 54.9352 34.1142 54.3741 33.7891L54.3723 33.788C53.8113 33.4629 53.0933 33.6551 52.7688 34.2174Z",
    fill: "#B77EC5"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M46.7525 35.2393L45.8102 36.8721C45.4857 37.4343 45.6775 38.1537 46.2387 38.4788L46.2404 38.4799C46.8016 38.8049 47.5195 38.6127 47.844 38.0505L48.7863 36.4178C49.1108 35.8555 48.919 35.1362 48.3578 34.811L48.356 34.81C47.7949 34.4849 47.077 34.6771 46.7525 35.2393Z",
    fill: "#8B3F9E"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M49.5301 32.7752C50.0912 33.1015 50.8103 32.9086 51.1338 32.3462L55.5029 24.7772C55.9555 23.9932 55.3901 23.0122 54.4869 23.0122C54.067 23.0122 53.6798 23.2359 53.4689 23.5992L49.0999 31.1682C48.7743 31.7305 48.9667 32.4509 49.528 32.7752H49.5301Z",
    fill: "#8B3F9E"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M47.4109 27.039C47.9721 27.3653 48.6911 27.1724 49.0147 26.6101L50.0736 24.7753C50.5263 23.9913 49.961 23.0103 49.0578 23.0103C48.6378 23.0103 48.2507 23.234 48.0397 23.5972L46.9808 25.432C46.6551 25.9944 46.8476 26.7147 47.4088 27.039H47.4109Z",
    fill: "#B77EC5"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M40.5781 37.7115C41.0287 38.4956 42.1593 38.4975 42.612 37.7115L46.6676 30.6823C46.9932 30.1199 46.8007 29.3996 46.2395 29.0753C45.6782 28.749 44.9593 28.9419 44.6357 29.5042L40.5801 36.5335C40.3691 36.8967 40.3691 37.3462 40.5801 37.7094L40.5781 37.7115Z",
    fill: "#B77EC5"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M41.1706 28.457C41.7318 28.7833 42.4507 28.5904 42.7744 28.028L44.6547 24.771C45.1094 23.9849 44.5441 23.0039 43.6408 23.0039C43.2209 23.0039 42.8338 23.2276 42.6228 23.5909L40.7425 26.8479C40.4168 27.4103 40.6093 28.1306 41.1706 28.4549V28.457Z",
    fill: "#8B3F9E"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M37.8632 33.0007C38.3138 33.7847 39.4445 33.7868 39.8971 33.0007L40.4174 32.0998C40.7431 31.5374 40.5505 30.8171 39.9893 30.4928C39.4281 30.1665 38.7091 30.3594 38.3855 30.9217L37.8653 31.8227C37.6543 32.186 37.6543 32.6354 37.8653 32.9987L37.8632 33.0007Z",
    fill: "#8B3F9E"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M35.1582 28.293C35.6088 29.077 36.7395 29.079 37.1922 28.293L39.2281 24.765C39.6808 23.981 39.1175 23 38.2122 23C37.7923 23 37.4052 23.2237 37.1942 23.587L35.1582 27.1149C34.9473 27.4782 34.9473 27.9277 35.1582 28.2909V28.293Z",
    fill: "#B77EC5"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_bdd_0_1",
    x: 0,
    y: -3.05884,
    width: 100,
    height: 109.118,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_0_1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.847059 0 0 0 0 0.792157 0 0 0 0 0.792157 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_backgroundBlur_0_1",
    result: "effect2_dropShadow_0_1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 20
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.847059 0 0 0 0 0.792157 0 0 0 0 0.792157 0 0 0 0.09 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_dropShadow_0_1",
    result: "effect3_dropShadow_0_1"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect3_dropShadow_0_1",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVasanaChartLogo);
export default __webpack_public_path__ + "static/media/vasana-chart-logo.34f94ff87ae05db9ae9de74518f51a48.svg";
export { ForwardRef as ReactComponent };